import useMediaQuery from '@mui/material/useMediaQuery';

export type ViewportMode = 'phone' | 'tablet' | 'desktop';

export interface ViewportModeInfo {
  mode: ViewportMode;
  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isPortrait: boolean;
  isLandscape: boolean;
  hasCoarsePointer: boolean;
}

/**
 * Classifies the viewport for Synergist's deliberately separate responsive
 * render paths. Large, touch-first iPads report widths above the regular MUI
 * tablet breakpoint in landscape, so coarse-pointer devices remain tablets
 * through 1366 CSS pixels.
 */
const useViewportMode = (): ViewportModeInfo => {
  const isPhoneWidth = useMediaQuery('(max-width: 599.95px)');
  const isRegularTabletWidth = useMediaQuery('(min-width: 600px) and (max-width: 1199.95px)');
  const isLargeTabletWidth = useMediaQuery('(min-width: 1200px) and (max-width: 1366px)');
  const hasCoarsePointer = useMediaQuery('(pointer: coarse)');
  const isPortrait = useMediaQuery('(orientation: portrait)');

  const isPhone = isPhoneWidth;
  const isTablet = !isPhone && (isRegularTabletWidth || (isLargeTabletWidth && hasCoarsePointer));
  const isDesktop = !isPhone && !isTablet;

  return {
    mode: isPhone ? 'phone' : isTablet ? 'tablet' : 'desktop',
    isPhone,
    isTablet,
    isDesktop,
    isPortrait,
    isLandscape: !isPortrait,
    hasCoarsePointer,
  };
};

export default useViewportMode;
